export default [
  {
    path: "/changelog",
    name: "ReleaseNotes",
    component: () => import("@/views/releasenotes/ReleaseNotesOverview.vue"),
    // Reached from Help → Neuigkeiten, the release dialog and the command palette — not from the
    // sidebar, which is for the work itself.
    //
    // No permission gate: which highlights a user sees is decided per highlight on the server, so an
    // empty page is the correct "nothing for you" result.
    meta: { title: "releasenotes.title", requiresAuth: true },
  },
]
